import React, { useMemo, useState } from "react";
import Modal from "react-modal";
import ReactTable from "./tables/react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

// Google's API only returns the first 100 results for a given search term
// With a pageSize of 10, this means we have max of 10 pages
const maxPageCount = 10;
const pageSize = 10; // Google's API returns 10 results per query max
const apiKey = process.env.SEARCH_API_KEY;
const engineId = process.env.SEARCH_ENGINE_ID;
const defaultResult = { items: [], searchInformation: { totalResults: 0 } };

Modal.setAppElement("#___gatsby");

export default function Search() {
  const [result, setResult] = useState(defaultResult);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const closeModal = () => {
    setResult(defaultResult);
    setLoading(false);
    setOpenModal(false);
  };

  const doSearch = (page) => {
    if (!searchQuery) return;

    setLoading(true);
    let startIndex = page * pageSize;
    fetch(
      `https://www.googleapis.com/customsearch/v1?key=${apiKey}&cx=${engineId}&q=${searchQuery}&start=${startIndex}`,
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.error) {
          throw result.error.message;
        }
        setLoading(false);
        setResult(result);
      })
      .catch(console.error);
  };

  const handleKeyPress = (event) => {
    // if user presses enter key in search textbox, submit query
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    // if the query is not null or an empty string, open search results modal
    if (searchQuery) {
      setOpenModal(true);
    }
  };

  const setQuery = (query) => {
    // save user input, trimming empty space on left and right sides of string
    setSearchQuery(query.trim());
    // setSearchQuery
  };

  // pages of results available is total results divided by page size, rounded up. If that value is
  // greater than the maxPageCount, use the max value instead.
  const pageCount = useMemo(
    () => Math.min(Math.ceil(result.searchInformation.totalResults / pageSize), maxPageCount),
    [result],
  );

  return (
    <>
      <div className="uk-position-relative">
        <div className="uk-grid-collapse" data-uk-grid="true">
          <div className="uk-width-4-5@m uk-width-expand@s">
            <input
              type="text"
              aria-label="search query"
              placeholder="Search"
              className="uk-input"
              onChange={(event) => setQuery(event.target.value)}
              onKeyPress={handleKeyPress}
            />
          </div>
          <div className="uk-width-1-5@m uk-width-auto@s">
            <button
              className="uk-form-icon uk-form-icon-flip uk-button-primary"
              aria-label="Search"
              onClick={handleSubmit}
            >
              <FontAwesomeIcon icon={faSearch} size="1x" style={{ color: "#fff" }} />
            </button>
          </div>
        </div>
      </div>

      <Modal
        isOpen={openModal}
        contentLabel="Search Results"
        onRequestClose={closeModal}
        className="Modal uk-box-shadow-small cstm-modal cstm-modal-search"
        overlayClassName="Overlay"
      >
        <div className="uk-modal-body">
          <button className="uk-modal-close-default" type="button" aria-label="close" onClick={closeModal}>
            <i className="fas fa-times" />
          </button>
          <ReactTable
            data={result.items}
            sortable={false}
            columns={[
              {
                Header: "Search Results",
                id: "results",
                style: { whiteSpace: "unset" },
                accessor: (item) => (
                  <>
                    <ul className="uk-list uk-list-collapse">
                      <li>
                        <a href={item.link}>{item.title}</a>
                      </li>
                      <li>
                        <i>{item.formattedUrl}</i>
                      </li>
                      <li>{item.snippet}</li>
                    </ul>
                  </>
                ),
                disableSortBy: true,
                disableFilters: true,
              },
            ]}
            showPageSizeOptions={false}
            defaultPageSize={pageSize}
            // Manually control pagination to allow for querying results from google API
            pageCount={pageCount}
            manualPagination={true}
            autoResetPage={false}
            loading={loading}
            onFetchData={(state) => {
              console.log("Fetch", state);
              doSearch(state.pageIndex);
            }}
            defaultSorted={[{ id: "results", desc: false }]}
            // minRows={1}
          />
        </div>
      </Modal>
    </>
  );
}
